import { ORDER, ORDER_PAYMENT } from '@hive/status'
import { TFunction } from 'i18next'

export const ORDER_STATUS_IN_PROGRESS = [
  ORDER.CONFIRMED,
  ORDER.PACKING,
  ORDER.WAITING_FOR_PAYMENT,
  ORDER.ASSEMBLY_IN_PROGRESS,
  ORDER.WAITING_FOR_POST_PAYMENT,
  ORDER.ASSEMBLY_COMPLETE,
  ORDER.ACCEPTED_BY_COURIER,
  ORDER.WAITING_FOR_COURIER,
  ORDER.DELIVERY_IN_PROGRESS,
  ORDER.POST_PAYMENT_PAID,
  ORDER.WAITING_FOR_PICKUP,
]

export const ORDER_STATUS_BEFORE_ASSEMBLE_START = [
  ORDER.CONFIRMED,
  ORDER.CANCELED,
]

export function getOrderStatusLabel (status: number, t: TFunction) {
  switch (status) {
  case ORDER.REFUNDED:
    return { label: t('status.refunded'), color: 'red' }
  case ORDER.CANCELED:
    return { label: t('status.canceled'), color: 'red' }
  case ORDER.INITIAL:
    return { label: t('status.initial'), color: null }
  case ORDER.CONFIRMED:
    return { label: t('status.placed'), color: 'green' }
  case ORDER.PACKING:
    return { label: t('status.paid'), color: 'green' }
  case ORDER.WAITING_FOR_PAYMENT:
    return { label: t('status.waiting_for_payment'), color: 'yellow' }
  case ORDER.ASSEMBLY_IN_PROGRESS:
    return { label: t('status.assembly_in_progress'), color: 'violet' }
  case ORDER.ASSEMBLY_COMPLETE:
    return { label: t('status.assembly_complete'), color: 'green' }
  case ORDER.ACCEPTED_BY_COURIER:
    return { label: t('status.accepted_by_courier'), color: 'violet' }
  case ORDER.WAITING_FOR_COURIER:
    return { label: t('status.waiting_for_courier'), color: 'violet' }
  case ORDER.DELIVERY_IN_PROGRESS:
    return { label: t('status.delivery_in_progress'), color: 'violet' }
  case ORDER.POST_PAYMENT_PAID:
    return { label: t('status.post_payment_paid'), color: 'violet' }
  case ORDER.WAITING_FOR_POST_PAYMENT:
    return {
      label: t('status.waiting_for_post_payment'),
      color: 'violet',
    }
  case ORDER.DELIVERED:
    return { label: t('status.delivered'), color: 'green' }
  case ORDER.COMPLETED:
    return { label: t('status.completed'), color: 'green' }
  case ORDER.RECALL_CLIENT:
    return { label: t('status.recall_client'), color: 'red' }
  case ORDER.WAIT_FOR_SLOT_CHANGE:
    return { label: t('status.waiting_for_slot_change'), color: 'red' }
  case ORDER.SLOT_CHANGED:
    return { label: t('status.slot_changed'), color: 'blue' }
  case ORDER.WAITING_FOR_PICKUP:
    return { label: t('status.waiting_for_pickup'), color: 'green' }
  default:
    return {
      label: t('status.unknown', { status }),
      color: 'red',
    }
  }
}

export const getStepFromOrderStatus = (status: number) => {
  switch (status) {
  case ORDER.CONFIRMED:
    return 0
  case ORDER.ASSEMBLY_IN_PROGRESS:
  case ORDER.ASSEMBLY_COMPLETE:
    return 1
  case ORDER.ACCEPTED_BY_COURIER:
  case ORDER.WAITING_FOR_COURIER:
  case ORDER.DELIVERY_IN_PROGRESS:
    return 2
  case ORDER.DELIVERED:
  case ORDER.COMPLETED:
    return 3
  default:
    return 0
  }
}

export const getOrderPaymentStatusLabel = (
  paymentStatus: number,
  t: TFunction,
) => {
  switch (paymentStatus) {
  case ORDER_PAYMENT.UNKNOWN:
    return t('payment.unknown')
  case ORDER_PAYMENT.ARRIVED:
    return t('payment.arrived')
  case ORDER_PAYMENT.REJECTED:
    return t('payment.rejected')
  default:
    return t('payment.error')
  }
}

export const isOrderCancellable = (orderStatus: number) => {
  switch (orderStatus) {
  case ORDER.CONFIRMED:
    return true
  default:
    return false
  }
}

export const RECEIPT_TYPE_PREPAYMENT = 'prepayment'
export const RECEIPT_TYPE_FULLPAYMENT = 'fullpayment'
export const RECEIPT_TYPE_PREPAYMENT_REFUND = 'prepaymentrefund'
export const RECEIPT_TYPE_REFUND = 'refund'

export const formatOrderReceiptType = (receiptType: string, t: TFunction) => {
  switch (receiptType) {
  case RECEIPT_TYPE_PREPAYMENT:
    return { label: t('receipt.prepayment'), color: 'green' }
  case RECEIPT_TYPE_FULLPAYMENT:
    return { label: t('receipt.fullpayment'), color: 'green' }
  case RECEIPT_TYPE_PREPAYMENT_REFUND:
    return { label: t('receipt.prepaymentrefund'), color: 'violet' }
  case RECEIPT_TYPE_REFUND:
    return { label: t('receipt.refund'), color: 'red' }
  default:
    return {
      label: t('receipt.default'),
      color: 'red',
    }
  }
}
